export default "__VITE_ASSET__380d90c0__"